import { ElementRef } from "@angular/core";
import { VdsDialogRef } from "./dialog-ref";

export function getClosestDialog(element: ElementRef<HTMLElement>, openDialogs: VdsDialogRef<any>[]) {
    let parent: HTMLElement | null = element.nativeElement.parentElement;

    while (parent && !parent.classList.contains("vds-dialog-container")) {
        parent = parent.parentElement;
    }

    return parent ? openDialogs.find((dialog) => dialog.id === parent!.id) : null;
}
